<template>
  <div class="config-history-card my-1">
    <div class="config-timestamp pl-1">
      <span
        ><b>{{ configHistory.date }}</b>
      </span>
      <span class="text-thin ml-1">{{ configHistory.time }}</span>
    </div>
    <div class="config-version">
      <b-badge pill variant="light-primary">
        Version {{ configHistory.version }}
      </b-badge>
    </div>
    <div class="config-button d-flex">
      <atom-button
        :buttonId="`button-view`"
        buttonStyle="border"
        class="mr-1"
        @click="viewConfig"
        >View</atom-button
      >
      <atom-button
        :buttonId="`compare-config-button`"
        buttonStyle="border"
        @click="onClickCompareConfig"
      >
        <span class="button-text">Compare</span>
      </atom-button>
    </div>
  </div>
</template>

<script>
import { BBadge } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"

export default {
  name: "MoleculeConfigHistoryCard",
  components: {
    AtomButton,
    BBadge,
  },
  props: {
    configHistory: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  methods: {
    onClickCompareConfig() {
      const selectedNodeId = this.configHistory.nodeId
      const selectedConfigVersion = this.configHistory.version
      this.$emit(
        "onClickCompareConfiguration",
        selectedNodeId,
        selectedConfigVersion,
      )
    },

    viewConfig() {
      this.$emit(
        "onSelectedConfigData",
        this.configHistory.nodeName,
        this.configHistory.nodeId,
        this.configHistory.version,
        this.configHistory.timestamp
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.config-history-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    "config-timestamp config-version"
    "config-button config-button";
  border: 1px solid #ebe9f1;
  border-radius: 6px;
  padding: 10px;
  align-items: center;
}

.config-timestamp {
  grid-area: config-timestamp;
}

.config-version {
  grid-area: config-version;
}

.config-button {
  grid-area: config-button;
  margin-left: 15px;
  margin-top: 8px;
}

.text-thin {
  color: #b9b9c3;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .config-history-card {
    display: grid;
    grid-template-columns: 2.16fr 1fr 2fr;
    grid-template-areas: "config-timestamp config-version config-button";
    border: 1px solid #ebe9f1;
    border-radius: 6px;
    padding: 10px;
    align-items: center;
  }

  .config-button {
    margin-left: 0px;
    margin-top: 0px;
    justify-self: end;
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
